<script setup>
import MapMarker from "./MapMarker.vue";
const { items } = defineProps(['items'])

</script>

<template>    
    <MapMarker v-for="item in items" :item="item" :key="item.id"></MapMarker>
    
</template>

<style>
</style>